module.exports = __webpack_public_path__ + "img/10.709bf7c8.jpg";